/* eslint-disable prettier/prettier */
import { useEffect, useState } from 'react'

import { initFlowbite } from 'flowbite'

import { Pagination } from 'components'

import { _object } from 'utils/interfaces'

import { DeleteIcon, EditIcon } from 'assets/svg'
import { testimonialService } from 'services/testmonial.service'
import TestimonialEditModal from 'components/modal/testimonial-edit-modal'
import TestimonialAddModal from 'components/modal/testimonial-add-modal'

const Testimonialstab = () => {
  const [loading, setLoading] = useState(false)
  const [results, setResults] = useState<_object>({})
  const [loadAgain, setLoadAgain] = useState(false)
  const [filters, setFilters] = useState<_object>({
    q: '',
    page: 1,
    per_page: 25,
    sort: '-created_at'
  })
  const getTestimonial = () => {
    setLoading(true)

    testimonialService.getTestimonials(filters).then((results) => {
      setResults(results)
      setLoading(false)
    })
  }
  useEffect(() => {
    getTestimonial()
  }, [filters, loadAgain])

  const deleteTestmonial = (id: string) => {
    if (window.confirm('Are you sure you want to delete this testimonial?')) {
      testimonialService.deleteTestimonial(id).then((results: _object) => {
        if (results?.error === false) {
          setLoadAgain(true)
        }
      })
    }
    getTestimonial()
  }
  useEffect(() => {
    initFlowbite()
  })

  return (
    <>
      <div className="mb-4 flex items-center justify-between">
        <h1 className="text-2xl font-semibold">
          Testimonials <small>Total records: {results?.pagination?.total_items}</small>
        </h1>
        <button
          className="rounded-md border border-purple-900 bg-purple-900 hover:bg-purple-950 px-4 py-2 text-sm text-white font-medium"
          data-modal-target={'testimonial-add-modal'}
          data-modal-toggle={'testimonial-add-modal'}
          type="button"
        >
          Add New Testimonial
        </button>
      </div>
      <div className="overflow-x-auto rounded-lg bg-white shadow">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-100">
            <tr className="text-left text-sm font-medium text-gray-900">
              <th className="px-4 py-3 font-semibold">#</th>
              <th className="px-4 py-3 font-semibold">Name</th>
              <th className="px-4 py-3 font-semibold">Designation</th>
              <th className="px-4 py-3 font-semibold">Description</th>

              <th className="flex justify-end px-4 py-3 text-center font-semibold">Action</th>
            </tr>
          </thead>

          <tbody className="divide-y divide-gray-100 text-sm">
            {loading === false ? (
              results?.items?.map((item: _object, i: number) => {
                return (
                  <>
                    <tr className="hover:bg-gray-50" key={i}>
                      <td className="px-4 py-3">{i + 1}</td>
                      <td className="px-4 py-3">{item?.name}</td>
                      <td className="px-4 py-3">{item?.designation}</td>
                      <td className="px-4 py-3">{item?.description}</td>

                      <td className="text-end px-4 py-3 w-[100px]">
                        <button
                          type="button"
                          onClick={() => deleteTestmonial(item.id)}
                          title="Delete Slide"
                          className='me-2'
                        >
                          <DeleteIcon className="h-[20px] w-[20px]" />
                        </button>

                        <button
                          data-modal-target={`testimonial-modal${item?.id}`}
                          data-modal-toggle={`testimonial-modal${item?.id}`}
                          type="button"
                          title="Edit Slide"
                        >
                          <EditIcon className="h-[20px] w-[20px]" />
                        </button>
                      </td>
                    </tr>
                    <TestimonialEditModal id={item.id} />
                  </>
                )
              })
            ) : (
              <TestimonialSkeleton />
            )}
            {results?.items?.length <= 0 &&
              <td colSpan={12} className="text-center py-6 text-gray-500">
                <p>No record found</p>
              </td>}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      {results?.pagination?.total_pages > 1 && (
        <Pagination
          pageCount={results?.pagination?.total_pages}
          current_page={results?.pagination?.current_page}
          onPageChange={(e: _object) => {
            setFilters({ ...filters, page: e.selected + 1 })
          }}
        />
      )}

      <TestimonialAddModal />
    </>
  )
}
export default Testimonialstab

const TestimonialSkeleton = () => {
  return (
    <>
      <tr className="animate-pulse">
        <td className="px-4 py-3">
          <div className="h-4 w-6 rounded bg-gray-300"></div>
        </td>
        <td className="px-4 py-3">
          <div className="h-4 w-32 rounded bg-gray-300"></div>
        </td>
        <td className="px-4 py-3">
          <div className="h-4 w-12 rounded bg-gray-300"></div>
        </td>
        <td className="px-4 py-3">
          <div className="h-4 w-12 rounded bg-gray-300"></div>
        </td>
        <td className="flex justify-end gap-2 px-4 py-3">
          <div className="h-5 w-5 rounded-full bg-gray-300"></div>
          <div className="h-5 w-5 rounded-full bg-gray-300"></div>
          <div className="h-5 w-5 rounded-full bg-gray-300"></div>
        </td>
      </tr>
    </>
  )
}
